import React, { useState, useEffect, useContext } from "react";
import adjustbalance from '../../../../assets/Image/adjust balance .png'
import SettingTable from "../ManageSettings/SettingTable";
import tickets from "../../../../assets/Image/tickets.png";
import briefcase from '../../../../assets/Image/briefcase.png'
import cylinder from "../../../../assets/Image/gaspic.png";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../.././../utils/secure-route/AuthContext";
import { ToastContainer } from "react-toastify";
import { useToastHandler } from "../../../common/ToastHandler";
import CloseIcon from "../../../../assets/Image/close.png";
import useFormattingUtils from "../../../../context/useFormattingUtils";
import ReusableTable from "../../../common/ReusableComponent/reusableTable/ReusableTable";
import { ConstructionOutlined } from "@mui/icons-material";

function GeneralLedgerCashLedger() {
  const [showModal, setShowModal] = useState(false);
  const { user } = useContext(AuthContext);
  const [cashLedger, setCashLedger] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [businessCash, setBusinessCash] = useState();
  const [gasCash, setCashCash] = useState();
  const [cashType, setCashType] = useState("");
  const [lottoCash, setLottoCash] = useState();
  const storeid = user.store;
  const { Post } = useApi();
  const { handleToast } = useToastHandler();
  const { formatDate , formatCurrency } = useFormattingUtils();
  const [data, setData] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const cashTypeMapping = {
    "Business cash": "business_cash",
    "Gas cash": "gas_cash",
    "Lottery cash": "lottery_cash",
  };
const fetchCashLedgerData = async ({ page = 1, sort = "", searchTerm = "" } = {}) => {
  if (!startDate || !endDate || !cashType) {
    return { data: [], totalPages: 1, totalItems: 0 };
  }

  const requestData = {
    start_date: startDate,
    end_date: endDate,
    cash_type: cashType,
         search: searchTerm,  
    ...(sort && { sort }),
  };

  try {
    const response = await Post("cashLedger", requestData);

    const ledgerEntries = Array.isArray(response.data.cash)
      ? response.data.cash
      : response.data.cash?.results || [];

    setBusinessCash(response.data.current_business_cash);
    setCashCash(response.data.current_gas_cash);
    setLottoCash(response.data.current_lottery_cash);

    const formatted = ledgerEntries.map((item, index) => ({
      id: item.id || index,
      ...item,
      date: item.date ? formatDate(item.date) : "N/A",
      current_balance: item.curent_balance || item.current_balance,
    }));

    const itemsPerPage = 10;

    // ✅ Search Filtering
    const normalizedSearch = searchTerm.toLowerCase().trim();
    const filteredData = formatted.filter((item) =>
      item.invoice_no?.toLowerCase().includes(normalizedSearch) ||
      item.reason?.toLowerCase().includes(normalizedSearch)
    );

    const totalItems = filteredData.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const paginatedData = filteredData.slice((page - 1) * itemsPerPage, page * itemsPerPage);

    return {
      data: paginatedData,
      totalPages,
      totalItems,
    };
  } catch (error) {
    console.error("Error fetching cash ledger data:", error);
    handleToast({
      type: "ERROR",
      message: "Failed to fetch cash ledger data.",
    });
    return { data: [], totalPages: 1, totalItems: 0 };
  }
};


  // const fetchCashLedgerData = async ({ page = 1, sort = "" } = {}) => {
  //   if (!startDate || !endDate || !cashType) {
  //     return { data: [], totalPages: 1, totalItems: 0 };
  //   }

  //   const requestData = {
  //     start_date: startDate,
  //     end_date: endDate,
  //     cash_type: cashType,
  //     ...(sort && { sort }),
  //     page,
  //   };

  //   try {
  //     const response = await Post("cashLedger", requestData);

  //     const ledgerEntries = Array.isArray(response.data.cash?.results)
  //       ? response.data.cash.results
  //       : [];

  //     setBusinessCash(response.data.current_business_cash);
  //     setCashCash(response.data.current_gas_cash);
  //     setLottoCash(response.data.current_lottery_cash);

  //     // Fix the field mapping issue - map curent_balance to current_balance
  //     const formatted = ledgerEntries.map((item) => ({
  //       ...item,
  //       date: item.date ? formatDate(item.date) : "N/A",
  //       current_balance: item.curent_balance || item.current_balance, // Handle both spellings
  //     }));

  //     setCashLedger(formatted);
  //     setData(formatted)

  //     return {
  //       data: formatted,
  //       totalItems: response.data.cash?.total_items || 0,
  //       totalPages: response.data.cash?.total_pages || 1,
  //     };

  //   } catch (error) {
  //     console.error("Error fetching cash ledger data:", error);
  //     handleToast({
  //       type: "ERROR",
  //       message: "Failed to fetch cash ledger data.",
  //     });
  //     return { data: [], totalPages: 1, totalItems: 0 };
  //   }
  // };

  useEffect(() => {
    if (startDate && endDate && cashType) {
      fetchCashLedgerData({ page: 1, searchTerm: "" });
    }
  }, [startDate, endDate, cashType ]);


  const handleCashTypeChange = (e) => setCashType(e.target.value);
  const handleStartDateChange = (e) => setStartDate(e.target.value);
  const handleEndDateChange = (e) => setEndDate(e.target.value);

  const toggleModal = () => setShowModal(!showModal);

  const handleCashSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const payload = Object.fromEntries(formData.entries());
    payload.store = storeid;
    payload.type = "cash_ledger";

    try {
      const resp = await Post("bankCashAdjustmentData", payload);

      handleToast({
        type: "SUCCESS",
        message: "Cash adjustment data submitted successfully!"
      })

      setShowModal(false);
      // Trigger refresh of the table data
      setRefreshTrigger(prev => prev + 1);
    } catch (error) {

      if (error.response && error.response.data) {

        handleToast({
          type: "ERROR",
          message: "Error submitting cash adjustment data: " + (error.response?.data?.message || "Unknown error")
        });
      } else {

        handleToast({
          type: "ERROR",
          message: "Error submitting cash adjustment data!"
        })

      }
    }
  };

  const columns = [
    { header: "Date", field: "date" },
    { header: "Invoice No", field: "invoice_no" },
    { header: "Debit", field: "debit" },
    { header: "Credit", field: "credit" },
    { header: "Current Balance", field: "curent_balance" }, // Fixed field name
    { header: "Reason", field: "reason" },
  ];

  return (
    <>
      <ToastContainer />

      <div className="">
        <div className="responsive-box">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "120px",
              justifyContent: "center",
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            {/* Business Cash Card */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                maxWidth: "300px",
                minWidth: "280px",
                height: "166px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: "16px",
                padding: "16px",
                backgroundColor: "#4A5546",
                border: "1px solid #d0d7de",
                fontFamily: "Arial, sans-serif",
              }}
            >
              <div style={{ color: "#F4FFEE" }}>
                <h3 style={{ margin: "0", fontSize: "18px", color: "#F4FFEE" }}>Business</h3>
                <p
                  style={{
                    margin: "8px 0 0",
                    fontSize: "14px",
                    color: "#F4FFEE",
                  }}
                >
                  Current Balance: <strong>{formatCurrency(businessCash)}</strong>
                </p>
              </div>
              <div>
                <img
                  src={briefcase}
                  alt="Business Icon"
                  style={{
                    width: "70px",
                    height: "70px",
                    filter: "brightness(1.9)",
                    opacity: 0.4,
                  }}
                />
              </div>
            </div>

            {/* Lottery Cash Card */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                maxWidth: "300px",
                minWidth: "280px",
                height: "166px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: "16px",
                padding: "16px",
                backgroundColor: "#4A5546",
                border: "1px solid #d0d7de",
                fontFamily: "Arial, sans-serif",
              }}
            >
              <div style={{ color: "#F4FFEE" }}>
                <h3 style={{ margin: "0", fontSize: "18px", color: "#F4FFEE" }}>Lottery</h3>
                <p
                  style={{
                    margin: "8px 0 0",
                    fontSize: "14px",
                    color: "#F4FFEE",
                  }}
                >
                  Current Balance: <strong>{formatCurrency(lottoCash)}</strong>
                </p>
              </div>
              <div style={{ opacity: 0.5 }}>
                <img
                  src={tickets}
                  alt="Ticket Icon"
                  style={{
                    width: "80px",
                    height: "80px",
                    filter: "brightness(1.2)",
                    opacity: 0.8,
                  }}
                />
              </div>
            </div>

            {/* Gas Cash Card */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                maxWidth: "300px",
                minWidth: "280px",
                height: "166px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: "16px",
                padding: "16px",
                backgroundColor: "#4A5546",
                border: "1px solid #d0d7de",
                fontFamily: "Arial, sans-serif",
              }}
            >
              <div style={{ color: "#F4FFEE" }}>
                <h3 style={{ margin: "0", fontSize: "18px", color: "#F4FFEE" }}>Gas</h3>
                <p
                  style={{
                    margin: "8px 0 0",
                    fontSize: "14px",
                    color: "#F4FFEE",
                  }}
                >
                  Current Balance: <strong>{formatCurrency(gasCash)}</strong>
                </p>
              </div>
              <div style={{ opacity: 0.5 }}>
                <img
                  src={cylinder}
                  alt="Gas Icon"
                  style={{
                    width: "70px",
                    height: "70px",
                    filter: "brightness(1.2)",
                    opacity: 0.5,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="responsive-box">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="mb-1">Cash Ledger</h3>
              <button onClick={toggleModal}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#FFAF32",
                  boxShadow: "none",
                  outline: "none",
                  width: "auto",
                  height: "42px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  border: "none",
                  borderRadius: "10px",
                  color: "#000",
                  cursor: "pointer",
                  fontWeight: 'bold',
                  gap: "8px",
                }}
              >
                Adjust Balance
                <img
                  src={adjustbalance}
                  alt="adjust balance Icon"
                  style={{ width: "20px", height: "20px", marginLeft: "18px" }}
                />
              </button>
            </div>

            {/* Filter Controls */}
            <div style={{ display: "flex", gap: "0px", marginBottom: "20px" }}>
              <div style={{ position: "relative", width: "242px" }}>
                <select
                  style={{
                    boxSizing: "border-box",
                    width: "203px",
                    height: "47px",
                    background: "#FFFFFF",
                    border: "1px solid #DBDBDB",
                    borderRadius: "10px 10px 10px 10px",
                    padding: "5px",
                    fontSize: "14px",
                    outline: "none",

                  }}
                  className="input-select"
                  name="cash_type"
                  required
                  value={cashType}
                  onChange={handleCashTypeChange}
                >
                  <option value="">Select Cash Type</option>
                  <option value="Business cash">Business Cash</option>
                  <option value="Gas cash">Gas Cash</option>
                  <option value="Lottery cash">Lottery Cash</option>
                </select>

              </div>

              {/* Date Range */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #DBDBDB",
                  borderRadius: "10px",
                  width: "400px",
                  padding: "5px",
                  background: "#FFFFFF",
                  gap: "8px",
                }}
              >
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={handleStartDateChange}
                  style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    fontSize: "14px",
                    backgroundColor: "transparent",
                  }}
                />

                <span style={{ fontSize: "14px", fontWeight: "bold" }}>to</span>

                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={handleEndDateChange}
                  style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    fontSize: "14px",
                    backgroundColor: "transparent",
                  }}
                />
              </div>
              <button
                type="button"
                onClick={() => {
                  setStartDate("");
                  setEndDate("");
                  setCashType("");
                  setCashLedger([]);
                  setData([]);
                  setRefreshTrigger(prev => prev + 1);
                }}
                style={{
                  marginLeft: "12px",
                  padding: "10px 18px",
                  backgroundColor: "#cccccc",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Clear
              </button>

            </div>
            {startDate && endDate && cashType && (
              <ReusableTable
                fetchData={fetchCashLedgerData}
                columns={columns}
                enablePagination={true}
                itemsPerPage={10}
                refreshKey={refreshTrigger}
                showFooter={true}
                showAction={false}
                showExport={true}
                showFilter={false}
              />
            )}
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div
            style={{
              position: "fixed",
              top: "10px",
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1000,
            }}
            onClick={toggleModal}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "700px",
                backgroundColor: "white",
                margin: "100px auto",
                borderRadius: "20px",
                position: "relative",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "none",
                }}
              >
                <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                  Adjust Balance
                </h5>
                <img
                  src={CloseIcon}
                  alt="Close"
                  width="34"
                  height="34"
                  onClick={toggleModal}
                />
              </div>

              <div className="modal-body">
                <form onSubmit={handleCashSubmit}>
                  <div className="row">
                    <div className="col-md-4" >
                      <input
                        style={{
                          height: "52px",
                        }}
                        type="date"
                        className="form-control-borderless"
                        name="date"
                        required
                      />
                    </div>

                    <div className="col-md-4">
                      <select
                        style={{
                          width: "240px",
                          height: "52px",
                        }}
                        type="number"
                        className="input-select"
                        name="cash_type"
                        required
                      >
                        <option value="" disabled selected>  Select Cash Type </option>
                        <option value="Business cash">Business Cash</option>
                        <option value="Gas cash">Gas Cash</option>
                        <option value="Lottery cash">Lottery Cash</option>
                      </select>
                    </div>

                    <div className="col-md-4">
                      <input
                        style={{
                          width: "150px",
                          marginLeft: "45px",
                          height: "52px",
                        }}
                        type="number"
                        className="form-control-borderless"
                        placeholder="$ 100"
                        name="amount"
                        min="0"
                        required
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9.]/g, '')
                            .replace(/^(\d*\.?\d{0,2}).*/g, '$1')
                            .slice(0, 12);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-md-12 text-end">
                      <button
                        type="submit"
                        className="btn"
                        style={{
                          color: "white",
                          backgroundColor: "#282e26",
                          borderRadius: "50px",
                          width: "181px",
                          height: "45px",
                          fontWeight: "bold",
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default GeneralLedgerCashLedger;